import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SvgLoaderComponent } from '../../images/svg-loader/svg-loader.component';

@Component({
  selector: 'app-tab-bar',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent],
  templateUrl: './tab-bar.component.html',
  styleUrl: './tab-bar.component.scss'
})
export class TabBarComponent {
  @Input() tabs: any;
  @Input() activeTab: any;
  @Input() mb: string = "0px";
  @Input() mt: string = "0px";

  onClickTab(tab): void {
    tab.onClick();
  }
}
